import { useEffect, useRef } from 'react';
import { Wrapper, Status } from '@googlemaps/react-wrapper';

interface MapComponentProps {
  center: google.maps.LatLngLiteral;
  zoom: number;
  className?: string;
}

const MapComponent = ({ center, zoom, className }: MapComponentProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      new google.maps.Map(ref.current, {
        center,
        zoom,
        minZoom: 3,
        maxZoom: 18,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: true,
      });
    }
  }, [center, zoom]);

  return <div ref={ref} className={className} />;
};

const render = (status: Status) => {
  switch (status) {
    case Status.LOADING:
      return (
        <div className="flex items-center justify-center h-full">
          Loading...
        </div>
      );
    case Status.FAILURE:
      return (
        <div className="flex items-center justify-center h-full text-red-500">
          Error loading map
        </div>
      );
    case Status.SUCCESS:
      return (
        <MapComponent
          center={{ lat: 36.7783, lng: -119.4179 }}
          zoom={7}
          className="w-full h-full"
        />
      );
  }
};

export const Map = () => {
  return (
    <div className="w-full h-full min-h-[400px]">
      <Wrapper
        apiKey={process.env.PUBLIC_GOOGLE_API_KEY || ''}
        render={render}
      />
    </div>
  );
};
